module.exports = __webpack_public_path__ + "pawn_black.png?c14987e90d7babd3dda675191bac2d83";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art/pawn_black.png
// module id = 116
// module chunks = 0